import { NewStatusAnimation } from '../types';

export const MARKER_ARRIVAL_EFFECTS = [
  'jump',
  'jump-spin',
  'vibrate',
  'glow',
  'zoom',
  'swing',
  'flip',
  'pulse',
  'wobble',
  'rubber-band',
] as const;

export type MarkerArrivalEffect = typeof MARKER_ARRIVAL_EFFECTS[number];

export const MIN_MADNESS_ANIMATION_DELAY_MS = 1;
export const MAX_MADNESS_ANIMATION_DELAY_MS = 10_000;

function hashMarkerKey(key: string, seed: number): number {
  let hash = seed | 0;
  for (let index = 0; index < key.length; index += 1) {
    hash = Math.imul(hash ^ key.charCodeAt(index), 0x45d9f3b);
    hash ^= hash >>> 16;
  }
  return hash >>> 0;
}

export function randomMarkerArrivalEffect(random: () => number = Math.random): MarkerArrivalEffect {
  const index = Math.min(
    MARKER_ARRIVAL_EFFECTS.length - 1,
    Math.floor(Math.max(0, random()) * MARKER_ARRIVAL_EFFECTS.length),
  );
  return MARKER_ARRIVAL_EFFECTS[index];
}

export function markerArrivalEffectForKey(key: string, seed: number): MarkerArrivalEffect {
  return MARKER_ARRIVAL_EFFECTS[hashMarkerKey(key, seed) % MARKER_ARRIVAL_EFFECTS.length];
}

export function markerArrivalDelayForKey(key: string, seed: number): number {
  const delayRange = MAX_MADNESS_ANIMATION_DELAY_MS - MIN_MADNESS_ANIMATION_DELAY_MS + 1;
  return MIN_MADNESS_ANIMATION_DELAY_MS + (hashMarkerKey(`delay:${key}`, seed) % delayRange);
}

export function markerAnimationDuration(animation: NewStatusAnimation): number | null {
  if (animation === NewStatusAnimation.FIVE_SECONDS) return 5_000;
  if (animation === NewStatusAnimation.TEN_SECONDS) return 10_000;
  return null;
}
